import {
  BigIntResolver,
  DateTimeResolver,
  EmailAddressResolver,
  HexColorCodeResolver,
  JSONResolver,
} from 'graphql-scalars';
import type { Resolvers } from '../../generated';

export const resolvers: Resolvers = {
  BigInt: BigIntResolver,
  DateTime: DateTimeResolver,
  JSONClient: JSONResolver,
  HexColorCode: HexColorCodeResolver,
  EmailAddress: EmailAddressResolver,
};
